import $ from 'jquery';
import Form from 'biogas/form.js';

export default function () {
    var me;
    var tbody;
    var opts;
    var model;
    var templates;
    var columns;
    var editable;
    var certificateEditable;
    
    function updateEntry(m, me, val, oldval, txt) {
        // validity check
        if (m.min !== undefined) {
            if (parseFloat(val) < m.min) {
                return false;
            }
        }
        var itemid = me.parent('tr').attr('data-id');

        var classes = me.attr('class').split(' ');
        $('tr[data-id='+itemid+'] td.' + classes[0]).removeClass('editing');
        me.removeClass('editing');
        
        me.removeClass('editing');
        if (val != oldval) {
            me.attr('data-value', val);
            me.find('input').hide();
            me.find('select').hide();
            var l = me.find('.loader');
            if (!l.length) {
                me.append('<img src="/images/loader.gif" class="loader">');
            }

            var savedVal = val;
            if (m['key'] === 'amount' && ['modelE', 'modelV'].includes(model['rowLabel'])) {
                val = {oldAmount: oldval, newAmount: val};
            }
            m.update(model, itemid, m, val, function (err, data) {
                val = savedVal;
                if (err) {
                    me.attr('data-value', oldval);
                    me.find('input').show();
                    me.find('select').show();
                    me.find('input').focus();
                    me.find('.loader').remove();
                    switch (m.type) {
                        case 'text':
                        case 'textarea':
                        case 'number':
                            me.find('input').val(val);
                            break;
                    }
                    me.removeClass('editing').addClass('editing');
                }
                if (!err) {
                    var elem = txt;
                    if (m.template) {
                        if (typeof m.template == 'function') {
                            elem = m.template(m.key, data);
                        } else {
                            elem = m.template
                        }
                    }
                    me.text(elem);
                    me.removeClass('editing');
                    
                    var tr = me.parent('tr');
                    var editchildren = tr.children('.editing');
                    if (!editchildren.length) {
                        tr.removeClass('tr-editing');
                    }
                    if (m.key == 'comment') {
                        $('tr[data-comment=' + itemid + '] td').text(elem);
                    }
                }
            });
        } else {
            var tr = me.parent('tr');
            var editchildren = tr.children('.editing');
            if (!editchildren.length) {
                tr.removeClass('tr-editing');
            }
            me.html(txt);
        }
        return true;
    }
    
    function writeForm(m, key, data, oldval)
    {
        var frm = {};
        
        switch (m.type) {
            case 'select':
                frm = {
                    items: [
                        {
                            type: 'select',
                            key: key,
                            elements: data,
                            elemkey: m.elemkey,
                            elemvalue: m.elemvalue,
                            value: oldval
                        }
                    ]
                };
                break;
            case 'text':
                frm = {
                    items: [
                        {
                            type: 'text',
                            key: key,        
                            value: oldval
                        }
                    ]
                }
                break;
            case 'textarea':
                frm = {
                    items: [
                        {
                            type: 'textarea',
                            key: key,        
                            value: oldval
                        }
                    ]
                }
                break;
            case 'number':
                var item = {
                    
                    type: 'number',
                    key: key,        
                    value: oldval,
                    min: m.min
                };
                if (m.min !== undefined) {
                    item.min = m.min;
                }
                if (m.step != undefined) {
                    item.step = m.step;
                }
                frm = {
                    items: [
                       item
                    ]
                }
                break;
            case 'file' :
                console.log("Get a file in write form");
                break;
     
        }
        var f = Form.new(frm);
        var h = f.out();

        return h;
    }

    function printForm(me, key, data)
    {
        var m = model[key];
        var oldval = me.attr('data-value');
        if (oldval === undefined) {
            oldval = '';
        }
        var h = writeForm(m, key, data, oldval);

        me.removeClass('editing').addClass('editing');
        me.html(h);
        
        var tr = me.parents('tr');       
        tr.removeClass('tr-editing').addClass('tr-editing');

        switch (m.type) {
            case 'select':
                me.find('form').submit(function (e) {
                    var val = $(this).find('select').val();
                    var txt = $(this).find(":selected").text();
                    if (updateEntry(m, me, val, oldval, txt)) {
                        e.preventDefault();
                    }
                });
                me.find('select').change(function (e) {
                    var val = $(this).val();
                    var txt = $(this).find(":selected").text();
                    updateEntry(m, me, val, oldval, txt);
                });
                break;
            case 'text':
            case 'number':
                me.find('form').submit(function (e) {
                    var val = $(this).find('input').val();
                    if (updateEntry(m, me, val, oldval, val)) {
                        e.preventDefault();
                    }
                });
                me.find('input').change(function (e) {
                    var val = $(this).val();
                    if (updateEntry(m, me, val, oldval, val)) {
                        e.preventDefault();
                    }
                });
                me.find('input').keypress(function (e) {
                    if (e.which == 13) {
                        var val = $(this).val();
                        if (updateEntry(m, me, val, oldval, val)) {
                            e.preventDefault();
                        }
                    }
                });
                break
            case 'textarea':
                me.find('form').submit(function (e) {
                    var val = $(this).find('textarea').val();
                    if (updateEntry(m, me, val, oldval, val)) {
                        e.preventDefault();
                    }
                });
                me.find('input').change(function (e) {
                    var val = $(this).val();
                    if (updateEntry(m, me, val, oldval, val)) {
                        e.preventDefault();
                    }
                });
                break;
            case 'file':
                console.log("file in print form");
                break;
        }
    }

    function loadData() {
        
        // empty body and set load screen
        //tbody.html('<tr><td colspan="' + (keys.length + 1) + '"><img src="https://www.addressix.com/img/loader.gif"></td></tr>');
        
        // get data for set
        var params = opts.data;
        if (opts.limit) {
            params.limit = opts.limit;
            params.offset = opts.offset;
        }
        
        $.ajax({
            type: "GET",
            url: opts.url,
            data: params,
            dataType: 'json'
        }).done(function (data) {
            tbody.html('');
            var html = '';
            for (var i = 0; i < data.length; i++) {
                if (opts.rowhandler) {
                    opts.rowhandler(data);
                }
                if (opts.idcol) {
                    html += '<tr data-id="' + data[i][opts.idcol] + '" data-label="' + model.rowLabel + '">';
                } else {
                    html += '<tr>';
                }
                if (opts.multiselect) {
                    html += '<td></td>';
                }
                var addline = '';
                for (var j = 0; j < columns.length; j++) {
                    var key = columns[j];
                    var m = model[key];
                    var elem;

                    if (!m) {
                        continue;
                    }

                    if (m.template) {
                        if (typeof m.template == 'function') {
                            elem = m.template(key, data[i]);
                        } else {
                            elem = m.template
                        }
                    }
                    else if (m.printCol) {
                        elem = data[i][m.printCol];
                    }
                    else if (data[i][key] !== undefined) {
                        elem = data[i][key];
                    }
                    else {
                        elem = '';
                    }
                    if (elem === null) {
                        elem = '';
                    }
                    html += '<td class="' + key;
                    if (m.cssclass) {
                        html += ' ' + m.cssclass;
                    }
                    if (m.edit) {
                        if (m.editable && typeof m.editable == 'function') {
                            if (m.editable(data[i])) {
                                html += ' dt-celledit';
                            }
                        } else {
                            html += ' dt-celledit';
                        }
                    }
                    html += '" data-key="' + key + '"';
                    if (m.valCol) {
                        if (data[i][m.valCol] !== null) {
                            html += ' data-value="' + data[i][m.valCol] + '"';
                        } else {
                            html += ' data-value=""';
                        }
                    }
                    html += '>' + elem + '</td>';


                    if (key == 'comment') {
                        addline = '<tr data-comment="' + data[i][opts.idcol] + '" class="onlyprint"><td colspan="' + (columns.length - 2) + '">' + elem + '</td></tr>';
                    }
                }
                html += '</tr>';
                if (addline) {
                    html += addline;
                }

            }
            tbody.html(html);
            
            // add handlers

            tbody.click(function (e) {
                var me = $(e.target);
                if (!me.is('td')) {
                    me = me.parents('td');
                }
                if (!editable && !certificateEditable) return;
                if (!me.length) return;
                if (me.hasClass('editing')) return;
                
                var key = me.attr('data-key');
                if (key === undefined) return;
                var tr = me.parents('tr');
                var t = $(e.target);
                var id = tr.attr('data-id');
                if (key == "certificate") {
                    e.stopPropagation();
                    var div = $(`#certificate-${id}`);
                    if (t.hasClass('add-certificate')) {
                        //
                        // Kludge alert.  Click is being called multiple times, which is causing 
                        // multple addCertificate requests. Until we find out how to stop the 
                        // multiple requests (stopPropagation and preventDefault are not working)
                        // we will live with the kludge
                        //
                        if (model.getEventTimestamp() == e.timeStamp) return;
                        model.setEventTimestamp(e.timeStamp);

                        model.addCertificate(me, id, function (err) {
                            if (err) { 
                                model.stopPropogation();
                                return;
                            }
                            model.repopulateCertificate(div, id, true);
                        });
                    }
                    if (t.hasClass('delete-certificate')) {
                        model.deleteCertificate(me, id, function (err) {
                            if (err) return;
                            model.repopulateCertificate(div, id, false);
                        });
                    }
                    return;
                }

                if (!editable) return;
                if (key == "actions") {
                    if (t.hasClass('delete')) {
                        model.deleteEntry(me, id, function (err) {
                            if (err) return;
                            tr.remove();
                            model.recompute(me);
                        });
                    }
                    else if (t.hasClass('ok')) {
                        tr.find('form').each(function () {
                            $(this).submit();
                        });
                    }
                }
                if (model[key].edit === undefined) return;
                if (model[key].editable && (typeof model[key].editable == 'function')) {
                    // check if this entry is editable
                    var data = {};
                    for (var prop in model) {
                        if (model.hasOwnProperty(prop)) {
                            data[prop] = tr.find('td[data-key=' + prop + ']').attr('data-value');                            
                        }
                    }
                    if (!model[key].editable(data)) {
                        return;
                    }
                }
                if (typeof model[key].edit == "function") {
                    model[key].edit(me, model[key], e);
                } else {
                    if (model[key]) {
                        // model-entry exists
                        if (typeof model[key].data == "function") {
                            if (model[key].dataCache) {
                                printForm(me, key, model[key].dataCache)
                            } else {
                                model[key].data(function (err, data) {
                                    model[key].dataCache = data;
                                    printForm(me, key, model[key].dataCache);
                                });
                            }
                        }                        
                        else {
                            printForm(me, key, model[key].data)
                        }
                    }
                }
            });

            if (opts.datahandler) {
                opts.datahandler(data);
            }            
        });
    }
    
    return {
        init: function (selector, options) {
            me = $(selector);
            if (!me.length) {
                throw new Error('Datatable: could not find selector ' + selector);
            }
            if (options.bodysel) {
                tbody = me.find(options.bodysel);
            } else {
                tbody = me.find('tbody .datacontent');
            }
            opts = {};
            opts.url = options.url;
            opts.offset = options.offset || 0;
            opts.limit = options.limit || 0;
            opts.data = options.data || {};
            opts.idcol = options.idcol || null;
            columns = options.columns || [];
            model = options.model || [];
            templates = options.templates || {};
            opts.datahandler = options.datahandler || null;
            editable = options.editable || true;

            if (model['header_fix']) {
                model['header_fix']['update']();
            }

            loadData();
            
            function frmAdd(e, tr) {
                var data = {};
                for (var i = 0; i < columns.length; i++) {
                    var key = columns[i];
                    var m = model[key];
                    var val = tr.find("[name=" + key + "]").val();
                    if (val !== undefined) {
                        data[key] = val;
                        tr.find('td.' + key).attr('data-value', val);
                    }
                }
                model.addEntry(tr, data, function (err, data) {
                    tr.attr('data-id', data[opts.idcol]);
                    for (var i = 0; i < columns.length; i++) {
                        var key = columns[i];
                        var td = tr.find('.' + key);
                        td.removeClass('editing');
                        var m = model[key];
                        var elem = '';                        
                        if (!m) {
                            continue;
                        }                        
                        if (m.template) {
                            if (typeof m.template == 'function') {
                                elem = m.template(key, data);
                            } else {
                                elem = m.template
                            }
                        }
                        else if (m.printCol && data[m.printCol]) {
                            elem = data[m.printCol];
                        }
                        else if (data[key] !== undefined) {
                            elem = data[key];
                        }
                        else {
                            elem = '';
                        }
                        if (elem === null) {
                            elem = '';
                        }

                        
                        td.html(elem);
                        if (m.valCol) {
                            td.attr('data-value', data[m.valCol]);
                        }
                    }
                    if (model.recompute) {
                        model.recompute();
                    }
                });
            }


            me.find('.addentry').click(function (e) {
                var tr = $('<tr data-id=""></tr>');
                tbody.append(tr);
                for (var i = 0; i < columns.length; i++) {
                    var m = model[columns[i]];
                    var td = $('<td class="' + columns[i] + ' editing" data-key="' + columns[i] + '"></td>');
                    tr.append(td);
                    if (m.edit) {
                        if (typeof m.edit == "function") {
                            m.edit(td, m, e);
                        } else {
                            if (m) {
                                // model-entry exists
                                if (typeof m.data == "function") {
                                    if (m.dataCache) {
                                        td.append(writeForm(m, columns[i], m.dataCache, ''));
                                    } else {
                                        m.data(function (err, data, cbd) {
                                            cbd.m.dataCache = data;
                                            var frm = writeForm(cbd.m, cbd.key, cbd.m.dataCache);
                                            cbd.td.append(frm);
                                        }, {
                                            td: td,
                                            m: m,
                                            key: columns[i]
                                        });
                                    }
                                }
                                else {
                                    td.append(writeForm(m, columns[i], m.dataCache, ''));
                                }
                            }
                        }
                    } else if (columns[i] == 'actions') {
                        var saveBtn = options.okbutton;
                        td.append(saveBtn);
                        var btn = td.find('button');
                        btn.click(function (e) {
                            frmAdd(e, tr);
                        })
                    }
                }
            });
        },
        
        setURL: function (url) {
            if (url != opts.url) {
                opts.url = url;
                loadData();
            } 
        },
        
        setCertificateEditable(toEditable) {
            certificateEditable = toEditable;
        },

        setEditable: function (toEditable) {
            editable = toEditable;
        },
        
        setFilter: function (name, value) {
            opts.data[name] = value;
            // reset offset
            opts.offset = 0;
            // reload data
            loadData();
        },

        loadData: function() {
          $('#errcard').hide();
          loadData();
        }

    }
};
